/* eslint-disable max-len */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { environment } from '../../../environments/environment';

function isPlatformAccessV1Only(): boolean {
  try {
    const raw = localStorage.getItem('user-data');
    if (!raw) {
      return false;
    }
    return JSON.parse(raw)?.platform_access_mode === 'V1_ONLY';
  } catch {
    return false;
  }
}

export function getHorizontalNavigation(onGisBlocked?: () => void): FuseNavigationItem[] {
  const gisDisabledByPlatform = isPlatformAccessV1Only();
  return [
    {
      id: 'myProjects',
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'المشاريع'
          : localStorage.getItem('lang') === 'ru'
          ? 'Проекты'
          : 'Projects',
      type: 'basic',
      icon: 'my:my-projects',
      link: '/projects/',
      hidden: () =>
        JSON.parse(localStorage.getItem('user-data')).role_name === 'ORG_OPERATION_ENGINEER',
    },
    // {
    //   id: 'audit',
    //   title: localStorage.getItem('lang') === 'ar' ? 'إدارة التدقيق' : 'Audit Management',
    //   badge: {
    //     title: localStorage.getItem('lang') === 'ar' ? 'جديد' : 'New',
    //     classes: 'beta ms-2 p-1 rounded-md bg-primary text-accent-800',
    //   },
    //   type: 'basic',
    //   icon: 'heroicons_solid:document-text',
    //   link: '/audit',
    //   hidden: () =>
    //     !JSON.parse(localStorage.getItem('user-data')).permissions.includes('AUDIT_REPORT'),
    // },
    {
      id: 'QHSE',
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'إدارة الجودة و السلامة الانشائية'
          : localStorage.getItem('lang') === 'ru'
          ? 'Управление ОТ, ПБ и качеством'
          : 'QHSE Management',
      /*badge: {
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'جديد'
          : localStorage.getItem('lang') === 'ru'
          ? 'Новый'
          : 'New',
      classes: 'beta ms-2 p-1 rounded-md bg-primary text-accent-800',
    },*/
      type: 'basic',
      icon: 'mat_solid:graphic_eq',
      link: '/qhse-management',
      hidden: () =>
        !JSON.parse(localStorage.getItem('user-data')).permissions.includes('AUDIT_REPORT'), //PERFORMANCE_MANAGEMENT
    },
    {
      id: 'analytics',
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'إحصائيات'
          : localStorage.getItem('lang') === 'ru'
          ? 'Аналитика'
          : 'Analytics',
      type: 'basic',
      icon: 'bar_chart',
      link: '/analytics',
      hidden: () =>
        !JSON.parse(localStorage.getItem('user-data')).permissions.includes(
          'SYSTEM_ACCESS_ANALYTICS_CHARTS',
        ),
    },
    {
      id: 'tools',
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'أدوات'
          : localStorage.getItem('lang') === 'ru'
          ? 'Инструменты'
          : 'Tools',
      type: 'basic',
      icon: 'build',
      link: '/tools',
      hidden: () =>
        !JSON.parse(localStorage.getItem('user-data')).permissions.includes('SYSTEM_ACCESS_TOOLS'),
    },
    {
      id: 'reportBuilder',
      badge: {
        title:
          localStorage.getItem('lang') === 'ar'
            ? 'جديد'
            : localStorage.getItem('lang') === 'ru'
            ? 'Новый'
            : 'New',
        classes: 'beta ms-2 p-1 rounded-md bg-primary text-accent-800',
      },
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'منشئ التقارير'
          : localStorage.getItem('lang') === 'ru'
          ? 'Report Builder'
          : 'Report Builder',
      type: 'basic',
      icon: 'mat_outline:summarize',
      hidden: () => {
        const userData = JSON.parse(localStorage.getItem('user-data'));
        return !userData?.report_builder_enabled || !environment.report_builder_url;
      },
      function: () => {
        const accessToken = localStorage.getItem('access_token');
        const reportBuilderUrl = environment.report_builder_url;
        window.open(`${reportBuilderUrl}/?token=${accessToken}`, '_blank');
        return false;
      },
    },
    {
      id: 'dms',
      badge: {
        title:
          localStorage.getItem('lang') === 'ar'
            ? 'جديد'
            : localStorage.getItem('lang') === 'ru'
            ? 'Новый'
            : 'New',
        classes: 'beta ms-2 p-1 rounded-md bg-primary text-accent-800',
      },
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'نظام إدارة المستندات'
          : localStorage.getItem('lang') === 'ru'
          ? 'DMS'
          : 'DMS',
      type: 'basic',
      icon: 'description',
      hidden: () => {
        const userData = JSON.parse(localStorage.getItem('user-data'));
        return !userData?.enable_dms_button; // Defaults to false if undefined
      },
      function: () => {
        const accessToken = localStorage.getItem('access_token');
        // TODO: DMS does not support Arabic; use 'en' when current lang is 'ar' until DMS adds Arabic support
        const currentLang = localStorage.getItem('lang') || 'en';
        const preferredLanguage = currentLang === 'ar' ? 'en' : currentLang;
        const dmsUrl = environment.dms_frontend_url;
        window.open(
          `${dmsUrl}?token=${accessToken}&preferred-language=${preferredLanguage}`,
          '_blank',
        );
        return false;
      },
    },
    {
      id: 'gis',
      badge: {
        title: 'New',
        classes: 'beta ms-2 p-1 rounded-md bg-primary text-accent-800',
      },
      title: 'GIS',
      type: 'basic',
      icon: 'mat_solid:map',
      hidden: () => false,
      classes: gisDisabledByPlatform ? { wrapper: 'opacity-40' } : {},
      function: () => {
        if (isPlatformAccessV1Only()) {
          onGisBlocked?.();
          return false;
        }
        const accessToken = localStorage.getItem('access_token');
        const gisUrl = environment.gis_frontend_url;
        const isInsideProject = /\/project-d\/[^/]+/.test(window.location.pathname);
        const v2ProjectId = isInsideProject ? sessionStorage.getItem('v2_project_id') : null;
        const path = v2ProjectId ? `/v2/home/project/${v2ProjectId}/PlanningGIS2D` : '/v2/home';
        const lang = localStorage.getItem('lang');
        const acceptLanguage = lang === 'ar' ? 'ar' : lang === 'ru' ? 'ru' : 'en';
        const gisFullUrl = `${gisUrl}${path}?token=${accessToken}&accept-language=${acceptLanguage}`;

        window.open(gisFullUrl, '_blank');
        return false;
      },
    },
    {
      id: 'superAdmin',
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'ضوابط المسؤول'
          : localStorage.getItem('lang') === 'ru'
          ? 'Панель администратора'
          : 'Admin Controls',
      hidden: () =>
        !JSON.parse(localStorage.getItem('user-data')).permissions.includes(
          'SYSTEM_ACCESS_ADMIN_SETTINGS',
        ),
      type: 'basic',
      icon: 'settings',
      link: 'admin',
    },
    //TODO:OPERATION SECTION
    {
      id: 'operation',
      title:
        localStorage.getItem('lang') === 'ar'
          ? 'التقارير قيد الانتظار'
          : localStorage.getItem('lang') === 'ru'
          ? 'Ожидающие отчеты'
          : 'Pending Reports',
      hidden: () =>
        JSON.parse(localStorage.getItem('user-data')).role_name !== 'ORG_OPERATION_ENGINEER',
      type: 'basic',
      icon: 'pending_actions',
      link: '/operation',
    },
  ];
}
